<template>
    <div :class="{'hstack':isHorizontal}" class="gap-2" >
        <slot name="label"></slot>
        <Multiselect :model-value="selectValue"
                        :class="{'is-valid':isComponentValid===true,'is-invalid':isComponentValid===false}"
                        :options="selectItems"
                        :mode="mode"
                        :close-on-select="true"
                        :label="'label'"
                        :rules="getRules"
                        :searchable="true"
                        :filter-results="true"
                        :strict="false"
                        :submit="false"
                        :disabled="isDisabled"
                        :disabled-prop="'isDisabled'"
                        :native-support="true"
                        @change="handleChange($event)"
                        @clear.prevent="handleClear"
                        :classes="{
                            tag: 'bg-secondary text-white text-sm py-0.5 pl-2 rounded mr-1 mb-1 flex items-center tagwidth-100 text-truncate rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1'
                        }">
            <template v-slot:tag="{ option, handleTagRemove, disabled }">
        <div
          class="multiselect-tag"
          :class="{
            'is-disabled': disabled
          }"
        >
          <div class="d-inlineblock hstack bg-secondary text-white text-sm py-0.5 pl-2 rounded mr-1 mb-1 flex items-center rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1"></div>
          <span tabindex="-1" class="tagwidth-150 text-truncate">
            {{ option.label }}
          </span>
          <span
            v-if="!disabled"
            class="multiselect-tag-remove"
            @click.prevent="handleTagRemove(option, $event)"
          >
            <span class="multiselect-tag-remove-icon"></span>
          </span>
        </div>
      </template>            
        </Multiselect>

    </div>
</template>
<script lang="ts">
    import { defineComponent, watch, ref, defineExpose } from 'vue';    
    import type { PropType } from 'vue';
    import { SelectItem } from '../../types';
    import Multiselect from '@vueform/multiselect'
    import {isText} from '@/utils'; 
    export default defineComponent({
        components: {
            Multiselect
        },
        props: {
            selectItems:Object as PropType<SelectItem[]>,
            isDisabled: {
                readonly: false,
                default: false,
                type: Boolean
            },
            modelValue: {
                type: Object as any, 
                required: false
            },
            isHorizontal: {
                readonly: false,
                default: false,
                type: Boolean
            },
            isRequired: {
                readonly: false,
                default: false,
                type: Boolean
            },
            mode: {
                default:'single',
                type:String
            },
            min:{
                default:-1,
                type:Number
            },
            max:{
                default:-1,
                type:Number
            },
            isActionTaken:{
                default:false,
                type:Boolean
            },
            isNullableBool:{
                default:false,
                type:Boolean
            }
        },
        computed: {            
            getRules():String[]{
                let rules = [] as String[];

                if(this.isRequired){
                    rules.push('required');
                }
                
                if(this.min != -1){
                    rules.push(`min:${this.min}`)
                }

                if(this.max != -1){
                    rules.push(`max:${this.max}`)
                }

                return rules;
            }
        },
        methods: {
            handleChange(e:any){ 
                if(e){
                    let value = (isText(e) || e?.value == undefined)? e : e.value;         
                    const regex = new RegExp('^[0-9]+$');
                    if(this.isActionTaken && (value == 'NONE' || value.indexOf('NONE')>=0)){
                        this.$emit('update:modelValue', 'NONE');
                    }
                    else if(this.mode == 'single') {                                           
                        if(this.isNullableBool && value == -99){
                            value = undefined;
                        }

                        this.$emit('update:modelValue', regex.test(value)?Number(value):value);
                    }
                    else if(value && !Array.isArray(value)){
                        if(!regex.test(value)){
                            let stringArray = [] as string[];

                            stringArray.push(value);

                            this.$emit('update:modelValue', stringArray);
                        }
                        else {
                            let numberArray = [] as number[];

                            numberArray.push(Number(value));

                            this.$emit('update:modelValue', numberArray);
                        }
                    }
                    else{
                        this.$emit('update:modelValue', value);
                    }
                }    
                
            },
            handleClear() {
                this.selectValue = "";
                this.$emit('update:modelValue', this.selectValue);
                this.isValid();
            }                        
        },
        setup(props, context){
            
            function getValue(value:any):any {
                if(props.mode != 'single'){
                    if(value == undefined){
                        value = [];
                    }
                    else if(!Array.isArray(value)) {
                        value = [value];
                    }

                    //Only set the valid values as selected otherwise we end up with empty tags
                    let result = [] as string[];

                    [...value].map(item=> {
                        if(props.selectItems?.find(f=>f.value == item)){
                            result.push(item);
                        }
                    });

                    if(value.length != result.length) {
                        context.emit('update:modelValue', result);
                    }

                    return result;
                }
                
                if(props.isNullableBool && value == undefined){
                    value = -99;
                }

                return value;
            }

            var selectValue = ref(getValue(props.modelValue));
            var isComponentValid = ref();
            const isValid = ():Boolean => {
                
                if(props.isRequired){
                    isComponentValid.value = selectValue?.value != undefined && selectValue?.value != -1 && selectValue?.value.length != 0;
                }
                else{
                    isComponentValid.value = true;
                }

                return isComponentValid.value;
            }

            defineExpose({ isValid })
            
            return {selectValue, getValue, isValid, isComponentValid};
        },
        watch: {
            modelValue(newValue, oldValue) {                
                
                this.selectValue = this.getValue(newValue);
            }
        }
    });
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style>
.form-select {
    padding: .5rem 2.25rem .5rem .75rem !important;
}
</style>
<!-- <script setup lang="ts">
    import { defineComponent, watch, ref, defineExpose, defineProps, computed } from 'vue';    
    import type { PropType } from 'vue';
    import { SelectItem } from '../../types';
    import Multiselect from '@vueform/multiselect'
    import {isText} from '@/utils'; 

    const props = withDefaults(defineProps<{
            selectItems:SelectItem[],
            isDisabled?: boolean,
            modelValue?: any,
            isHorizontal?: boolean,
            isRequired?: boolean,
            mode?:"single" | "multiple" | "tags"| undefined,
            min?:number,
            max?:number,
            isActionTaken?: boolean,
            isNullableBool?:boolean 
        }>(), {
            selectItems:() => [],
            isDisabled: false,
            modelValue: undefined,
            isHorizontal: false,
            isRequired: false,
            mode: 'single',
            min: -1,
            max: -1,
            isActionTaken: false,
            isNullableBool: false            
        });

    const emit = defineEmits['update:modelValue'];
        var selectValue = ref(getValue(props.modelValue));
        var isComponentValid = ref();
        const isValid = ():Boolean => {
            
            if(props.isRequired){
                isComponentValid.value = selectValue?.value != undefined && selectValue?.value != -1 && selectValue?.value.length != 0;
            }
            else{
                isComponentValid.value = true;
            }

            return isComponentValid.value;
        }
            const getRules = computed(() => {
                let rules = [] as String[];

                if(props.isRequired){
                    rules.push('required');
                }
                
                if(props.min != -1){
                    rules.push(`min:${props.min}`)
                }

                if(props.max != -1){
                    rules.push(`max:${props.max}`)
                }

                return rules;
            });
                
            function handleChange(e:any){ 
                if(e){
                    let value = (isText(e) || e?.value == undefined)? e : e.value;         
                    const regex = new RegExp('^[0-9]+$');
                    if(props.isActionTaken && (value == 'NONE' || value.indexOf('NONE')>=0)){
                        emit('update:modelValue', 'NONE');
                    }
                    else if(props.mode == 'single') {                                           
                        if(props.isNullableBool && value == -99){
                            value = undefined;
                        }

                        emit('update:modelValue', regex.test(value)?Number(value):value);
                    }
                    else if(value && !Array.isArray(value)){
                        if(!regex.test(value)){
                            let stringArray = [] as string[];

                            stringArray.push(value);

                            emit('update:modelValue', stringArray);
                        }
                        else {
                            let numberArray = [] as number[];

                            numberArray.push(Number(value));

                            emit('update:modelValue', numberArray);
                        }
                    }
                    else{
                        emit('update:modelValue', value);
                    }
                }    
                
            }

            function handleClear() {
                selectValue.value = "";
                emit('update:modelValue', selectValue.value);
                isValid();
            }                        
        
        
            
            function getValue(value:any):any {
                if(props.mode != 'single'){
                    if(value == undefined){
                        value = [];
                    }
                    else if(!Array.isArray(value)) {
                        value = [value];
                    }

                    //Only set the valid values as selected otherwise we end up with empty tags
                    let result = [] as string[];

                    [...value].map(item=> {
                        if(props.selectItems?.find(f=>f.value == item)){
                            result.push(item);
                        }
                    });

                    if(value.length != result.length) {
                        emit('update:modelValue', result);
                    }

                    return result;
                }
                
                if(props.isNullableBool && value == undefined){
                    value = -99;
                }

                return value;
            }

           

            defineExpose({ isValid })
            
            
</script> -->
